import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetStaticProps } from "next/types";
import { useRouter } from "next/router";
import { NextSeo } from "next-seo";
import { useFlipperPageViews } from "@looksrare/classic-games/flipper";
import { Page } from "@/components";
import { getCanonicalAndLanguageAlternates, getChainInfo } from "@/utils";
import { YoloGamesFlipperProvider } from "@/components/YoloGamesFlipperProvider";

const FlipperView = dynamic(() => import("@looksrare/classic-games/flipper").then((module) => module.FlipperView), {
  ssr: false,
});

const FlipperPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentChainInfo = getChainInfo();

  // Ensure that the page view is tracked
  useFlipperPageViews();

  const title = "Flipper";
  const description = "A modern twist on a timeless format. Pick your side, flip the coin, and wait for the outcome.";
  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(
    "/flipper/",
    router,
    currentChainInfo.appUrl
  );

  return (
    <Page title={t("Flipper")} contentContainerProps={{ p: { base: 4, lg: 8 } }}>
      <NextSeo
        noindex
        nofollow
        title={title}
        description={description}
        openGraph={{
          url: canonical,
          title: t("{{pageTitle}} | YOLO Games", { pageTitle: title }),
          description: description,
          images: [
            {
              url: `${currentChainInfo.appUrl}/images/flipper/meta.png`,
              alt: "Flipper",
              width: 1600,
              height: 840,
              type: "image/png",
            },
          ],
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <YoloGamesFlipperProvider>
        <FlipperView />
      </YoloGamesFlipperProvider>
    </Page>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["flipper", "common"])),
    },
  };
};

export default FlipperPage;
